import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Ri5ApiService } from '../ri5-api.service';
import { UcExternalProperties } from './uc-external-properties.interface';

@Injectable()
export class Ri5UcsService extends Ri5ApiService {

  getExternalProperties(id: string): Observable<UcExternalProperties> {
    return this.get<UcExternalProperties>(`ucs/${id}/external-properties`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/ri5-api/ucs/ri5-ucs.service.ts